/* 🤖 this file was generated by svg-to-ts */
export const matIconDangerous: {
  name: 'dangerous';
  data: string;
} = {
  name: 'dangerous',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8zm-4.17-7.14L12 10.59 9.17 7.76 7.76 9.17 10.59 12l-2.83 2.83 1.41 1.41L12 13.41l2.83 2.83 1.41-1.41L13.41 12l2.83-2.83-1.41-1.41z"/></svg>`
};
